import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { itemDescriptionStyle } from '../../dropdown.vanilla.mjs';

const ItemDescription = forwardRef(
  ({ className, ...props }, ref) => {
    return /* @__PURE__ */ jsx(
      "p",
      {
        "data-scope": "legacy-dropdown",
        "data-part": "item-description",
        ref,
        className: classNames(itemDescriptionStyle, className),
        ...props
      }
    );
  }
);

export { ItemDescription };
//# sourceMappingURL=ItemDescription.mjs.map
